import React from 'react';
import { PromotionProgress } from '@vp/component-library';
import { useSelector } from 'react-redux';
import useSiteData from '../../hooks/useSiteData';
import { pricingSelectors } from '../../state/pricing';
import type { RootState } from '../../types';

export const PromotionProgressWrapper = () => {
  const { locale } = useSiteData();

  const fractionDigits = useSelector((state: RootState) =>
    pricingSelectors.selectFractionDigits(state.pricing)
  );
  const currency = useSelector((state: RootState) =>
    pricingSelectors.selectCurrency(state.pricing)
  );

  const discountSources = useSelector((state: RootState) =>
    pricingSelectors.selectDiscountSources(state.pricing)
  );

  return (
    <PromotionProgress
      discountSources={discountSources}
      currency={currency}
      fractionDigits={fractionDigits}
      locale={locale}
    />
  );
};
